import { API_BASE_URL } from '../const/constants.js';

/**
 * 获取 COS 预签名 URL
 * @returns {Promise<{ uploadUrl: string, downloadUrl: string }>}
 */
async function getPresignedUrl() {
  const res = await fetch(`${API_BASE_URL}demo-user/getPresignedUrl`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({}),
  });
  const data = await res.json();
  if (data.code === 0 && data.data) {
    return {
      uploadUrl: data.data.uploadUrl,
      downloadUrl: data.data.downloadUrl,
    };
  }
  throw new Error(data.message || '获取预签名URL失败');
}

/**
 * Base64 转 Blob
 */
function base64ToBlob(base64Data, contentType = 'application/octet-stream') {
  const pureBase64 = base64Data.replace(/^data:.+?;base64,/, '');
  const byteCharacters = atob(pureBase64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}

/**
 * 上传文件到 COS（通过预签名 URL）并返回下载地址
 * @param {Object} options
 * @param {string} options.base64 - 文件的 Base64 数据（可带或不带 data: 前缀）
 * @param {string} [options.contentType] - 文件 MIME 类型
 * @returns {Promise<string>} COS 文件下载 URL
 */
export async function uploadToCos({ base64, contentType = 'application/octet-stream' }) {
  const { uploadUrl, downloadUrl } = await getPresignedUrl();
  console.log('[COS Upload] 预签名URL:', { uploadUrl: uploadUrl?.substring(0, 80), downloadUrl: downloadUrl?.substring(0, 80) });

  const blob = base64ToBlob(base64, contentType);
  console.log('[COS Upload] Blob大小:', blob.size, 'bytes');

  const putRes = await fetch(uploadUrl, {
    method: 'PUT',
    body: blob,
  });

  console.log('[COS Upload] PUT响应:', putRes.status, putRes.statusText);

  if (!putRes.ok) {
    const errText = await putRes.text();
    console.error('[COS Upload] PUT失败:', errText);
    throw new Error(`COS上传失败: ${putRes.status} ${putRes.statusText}`);
  }

  return downloadUrl;
}

/**
 * 判断是否需要先上传 COS
 */
export function needCosUpload(action) {
  const COS_UPLOAD_ACTIONS = ['MultimodalDocParse'];
  return COS_UPLOAD_ACTIONS.includes(action);
}
